import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/hr/analytics',
}).lazy(() => import('./analytics.lazy').then((d) => d.Route))
